/* eslint-disable no-console */
/**
 * Entry point for webpack
 * Import styles, fonts, icons, scripts and other things that your project design requires here
 */

import objectFitImages from 'object-fit-images'
import svg4everybody from 'svg4everybody'
import Rellax from 'rellax'

import './styles/_font-face.scss'
import './styles/main.scss'
import './styles/_form.scss'
import './styles/_cta.scss'
import './styles/_reset.scss'
import './styles/_animations.scss'
import './styles/_page-animations.scss'
import './styles/blocks/_preloader.scss'
import './styles/blocks/_button.scss'
import './styles/blocks/_button-mini.scss'
import './styles/blocks/_header.scss'
import './styles/blocks/_cover.scss'
import './styles/blocks/_hero.scss'
import './styles/blocks/_page-section.scss'
import './styles/blocks/_menu.scss'
import './styles/blocks/_menu-show.scss'
import './styles/blocks/_circle.scss'
import './styles/blocks/_title.scss'
import './styles/blocks/_text.scss'
import './styles/blocks/_about.scss'
import './styles/blocks/_services.scss'
import './styles/blocks/_cards.scss'
import './styles/blocks/_offices.scss'
import './styles/blocks/_news.scss'
import './styles/booking-form-react/_ticket.scss'
import './styles/booking-form-react/_ticket-landing.scss'
import './styles/booking-form-react/_toggles.scss'
import './styles/blocks/_calendar.scss'
import './styles/blocks/_main-list.scss'
import './styles/blocks/_aircraft.scss'
import './styles/blocks/_fleet.scss'
import './styles/blocks/_features.scss'
import './styles/blocks/_certification.scss'
import './styles/blocks/_footer.scss'
import './styles/blocks/_steps.scss'
import './styles/blocks/_aircraft-info.scss'
import './styles/blocks/_showing.scss'
import './components/before-after/_before-after.scss'
import './styles/blocks/_specifications.scss'
import './styles/blocks/_highlights.scss'
import './styles/blocks/_card.scss'
import './styles/blocks/_advantages.scss'
import './styles/blocks/_two-columns-points.scss'
import './styles/blocks/_graph.scss'
import './styles/blocks/_circles.scss'
import './styles/blocks/_switch.scss'
import './styles/blocks/_details.scss'
import './styles/blocks/_vacancies.scss'
import './styles/blocks/_pagination.scss'
import './styles/booking-form-react/_contact-form.scss'
import './styles/blocks/_terms.scss'
import './components/scroll-progress/_scroll-progress.scss'
import './styles/booking-form-react/_ticket-contact.scss'
import './styles/blocks/_drop-down.scss'
import './styles/blocks/_section.scss'
import './styles/blocks/_patch.scss'
import './styles/blocks/_advertise-aircraft.scss'
import './styles/_styled-select.scss'
import './styles/booking-form-react/_atomic.scss'
import './career/modal.scss'
import './career/style.scss'

import form from './form'
import './scripts/menu'
import rangeSlider from './components/range-slider/range-slider'
import beforeAfter from './components/before-after/before-after'
import swiper from './components/swiper-slider/swiper-slider'
import circles from './scripts/circles'
import toTop from './scripts/to-top'
import lazyLoad from './scripts/lazy-load'
import changeInfo from './scripts/change-info-on-click'
import soundWave from './scripts/sound-wave'
import dropDown from './components/dropdown/dropdown'
import modal from './components/modal/modal'
import filter from './scripts/filter'
import videoPlayback from './scripts/video-playback'
import accordionDefinition from './scripts/accordion-definition'
import scrollProgress from './components/scroll-progress/scroll-progress'
import showRequestButton from './scripts/show-request-button'
import showButton from './scripts/show-button'
import hideButton from './scripts/hide-button'
import bookingFormReact from './booking-form-react'
import sectionAnimation from './scripts/show-section-animation'
import changeAccordionItemBg from './scripts/add-bg'
import initTabs from './components/tabs/tabs'
import makeSpaceForFooter from './scripts/make-space-for-footer'
import headerObserver from './scripts/header-observer'
import loadingAnimation from './scripts/loading-animation'
import splitWords from './scripts/split-words'
import initHeadroom from './scripts/init-headroom'
import './form/custom-selects-jquery'
import hoverableLogos from './scripts/hoverable-logos'
import './styles/_iti.scss'
import lazyFooterBg from './lazy-footer-bg'

import './career'

const animationObserver = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('animate')
    }
  })
})

// initialize things like header, footer
const oneTimeThings = () => {
  dropDown()
  svg4everybody()
  makeSpaceForFooter()
  toTop()
  initHeadroom()
  document.documentElement.classList.add('dom-loaded')
  lazyFooterBg()
}

// initialize things inside of data-barba="container"
const onPageLoad = page => {
  objectFitImages()

  const reactMountingPoint = page.querySelector('[data-react-root]')
  if (reactMountingPoint) {
    bookingFormReact(reactMountingPoint)
  }

  form(page)
  lazyLoad(page)
  accordionDefinition(page)
  scrollProgress(page)
  showRequestButton(page)
  showButton(page)
  dropDown(page)
  modal(page)
  rangeSlider(page)
  filter(page)
  changeInfo(page)
  videoPlayback(page)
  soundWave(page)
  hideButton(page)
  sectionAnimation(page)
  beforeAfter(page)
  swiper(page)
  initTabs(page)
  changeAccordionItemBg(page)
  headerObserver(page)
  splitWords(page)
  new Rellax('[data-rellax]')
  circles(page)
  hoverableLogos(page)
}

const afterPreloader = page => {
  animationObserver.disconnect()
  page.querySelectorAll('[data-element-animate]:not(.animate)').forEach(el => {
    animationObserver.observe(el)
  })
}

document.addEventListener('DOMContentLoaded', () => {
  oneTimeThings()

  const container = document.querySelector('[data-barba="container"]')

  try {
    onPageLoad(container)
  } catch (e) {
    console.error(e)
  }

  loadingAnimation().then(() => {
    setTimeout(() => {
      afterPreloader(container)
    }, 500)
  })
})

if ('jQuery' in window) {
  window.jQuery(document).ajaxComplete(() => {
    afterPreloader(document.body)
  })
}
